module.exports = __webpack_public_path__ + "static/img/图片11.d59ae30c.png";